import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { TypeDeSorts } from 'src/app/_enums/typeDeSort';
import { CommandResult } from 'src/app/_models/commandResult';
import { Competence } from 'src/app/_models/competence';
import { Joueur } from 'src/app/_models/joueur';
import { Sort } from 'src/app/_models/sort';
import { CreatePersonnageCommand } from 'src/app/_models/_commands/createPersonnageCommand';
import { CompetenceService } from 'src/app/_services/competence.service';
import { SortService } from 'src/app/_services/sort.service';
import { Astre, Astres } from '../../_enums/astre';
import { Legion, Legions } from '../../_enums/legion';
import { Personnage } from '../../_models/personnage';
import { CharacterSheetService } from '../../_services/character-sheet.service';

@Component({
  selector: 'app-character-sheet-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})
export class CharacterSheetPrintComponent implements OnInit {
  personnage!: Personnage;
  joueur!: Joueur;

  public legions = new Legions;
  public astres = new Astres;
  public typeDeSorts = new TypeDeSorts;
  sorts!: Sort[];
  competences!: Competence[];

  constructor(private characterSheetService: CharacterSheetService, private sortService: SortService, private competenceService: CompetenceService, private route: ActivatedRoute, private router: Router) {
   }

  ngOnInit(): void {
    var personnageId = 0;
    this.route.params.pipe(first()).subscribe(params => {
        personnageId = params['characterSheetId'];
      });
    
      this.characterSheetService.getPersonnage(personnageId)          
      .pipe(first())
      .subscribe({
        next: (personnage) => this.personnage = personnage,
      });
    
      this.characterSheetService.getJoueur()          
      .pipe(first())
      .subscribe({
        next: (joueur) => this.joueur = joueur,
      });
      
      this.sortService.getSorts()          
      .pipe(first())
      .subscribe({
        next: (sorts) => this.sorts = sorts,
      });
        
      this.competenceService.getCompetences()          
      .pipe(first())
      .subscribe({
        next: (competences) => this.competences = competences,
      });
  }

  public getCompetencesPersonnage() {
    return this.personnage.competences.map((c) => {
      return {      
        competence: c,
        description: this.competences.find((comp) => comp.id === c.competenceId)
      };
    });
  }

  public getSortsPersonnage() {
    return Array.from(this.typeDeSorts.values.entries()).map((typeDeSort) => {
      return {
        name: typeDeSort[1],
        sorts: this.personnage.sorts.map((s) => {
          return {      
            sort: s,
            description: this.sorts
              .find((sort) => sort.id === s.sortId && sort.type === typeDeSort[0])
          };
        }).filter((sort) => sort.description != null)
      }
    }).filter((sortPersonnage) => sortPersonnage.sorts.length > 0);
  }
}